import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=3f8aa4b2&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=3f8aa4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../edeone/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8aa4b2",
  null
  
)

export default component.exports